<template>
	<header class="main-header-component">
		<article class="container">
			<div class="contacts">
				<span class="title">ООО «Сибвалео Форин Трэйд»</span>
			</div>

			<div class="content">
				<div class="logo">
					<VLogo />
				</div>

				<nav class="menu">
					<a href="#know-how">Как это работет</a>
					<a href="#contacts">Контакты</a>
					<a href="#about-platform">О платформе</a>
				</nav>

				<div class="recall-form">
					<button
						class="btn round"
						@click="showOverlayContent"
					>
						<i class="material-icons">phone</i>
					</button>

					<button
						class="btn register"
						@click="goToLogin"
					>
						<span class="from-phone">Вход / регистрация</span>
						<span class="on-phone">Вход</span>
					</button>

					<button
						class="btn mobile-menu"
						@click="openMobileMenu"
					>
						<i class="material-icons">menu</i>
					</button>
				</div>
			</div>
		</article>
	</header>
</template>

<style scoped lang="scss" src="./MainHeader.scss"/>

<script>
import VLogo from "@/lib/components/VLogo/VLogo.vue";

import Core                from "@/core/Core";
import { getUserHomePath } from "@/router";

export default {
	name: 'MainHeader',

	components: {
		VLogo
	},

	computed: {
		overlayVisible() {
			return this.$store.getters['landing/overlayVisible'];
		},
		mobileMenuVisible() {
			return this.$store.getters['landing/mobileMenuVisible'];
		},
	},

	methods: {
		onOverlayClick(event) {
			if (event.target.id === 'mobile-menu-overlay') {
				this.$store.dispatch('landing/toggleGlobalOverlay', false);
			}
		},
		onMobileMenuOverlayClick(event) {
			if (event.target.id === 'mobile-menu-overlay') {
				this.closeMobileMenu();
			}
		},
		openMobileMenu() {
			this.$store.dispatch('landing/toggleMobileMenu', true);
		},
		showOverlayContent() {
			this.$store.dispatch('landing/toggleOverlayForm', 'make-recall');
		},
		goToLogin() {
			if (!Core.currentUser) {
				this.$router.push('/login');
			} else {
				this.$router.push(getUserHomePath());
			}
		},
	},
};
</script>